export const FIND_LEGACY_PERMISSIONS = 'legacyPermission@ FIND_LEGACY_PERMISSIONS';
export const SET_LEGACY_PERMISSIONS = 'legacyPermission@SET_LEGACY_PERMISSIONS';

export const findLegacyPermissions = (username, context) => ({ type: FIND_LEGACY_PERMISSIONS, username, context });
export const setLegacyPermissions = legacyPermissions => ({ type: SET_LEGACY_PERMISSIONS, legacyPermissions });